import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconFolder2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconFolder2"><Path d="M2 9V3H10.2491L12.3047 5H22V9H2Z" fill="currentColor"/><Path d="M2 10.5V20H22V10.5H2Z" fill="currentColor"/></CentralIconBase>;
});

export default IconFolder2;
